function replacementPartsAlgolia (algolia) {

  let container = document.getElementById('product-replacement-parts');
  if(!container) {
    return;
  }

  let replacementParts = JSON.parse(container.querySelector('[type="application/json"]').textContent);
  if(!replacementParts) {
    return;
  }
  const instantsearch = algolia.externals.instantsearch;
  const algoliasearch = algolia.externals.algoliasearch;

  const hits = algolia.externals.widgets.hits;
  let stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }
  }
  const search = instantsearch({
    searchClient: algoliasearch(
      algolia.config.app_id,
      algolia.config.search_api_key
    ),
    indexName: algolia.config.index_prefix + 'products',
    searchFunction: function (searchFunctionHelper) {

      let skus = replacementParts.split(',').map(item => {
        if(item) {
          return `sku:${item}`
        }
      }).filter(el => {
        return el !== undefined
      });
      let searchFilters = false;
      if (skus.length > 0) {
        searchFilters = skus.join(' OR ');
      }

      // Add the stock policy filter to the list of search filters
      if (stockPolicyFilter) {
        searchFilters += searchFilters ? ' AND ' + stockPolicyFilter : stockPolicyFilter;
      }
      if (searchFilters) {
        searchFunctionHelper.setQueryParameter(
          'filters',
          searchFilters
        );
      }

      searchFunctionHelper.search();
    },
  });


  search.addWidgets([
    hits({
      container: '#product-replacement-parts__items',
      cssClasses: {
        item: 'product-replacement-parts__item',
        list: ['page-width', 'product-replacement-parts__items', 'isolate', 'list-unstyled']
      },
      templates: {
        item(hit, { html, components }) {
          let form = html`<form action="/cart/add" class="product-replacement-parts__form">
          <input type="hidden" value="${hit.objectID}" name="id" />
          <input type="hidden" value="${hit.id}" name="product-id" />
          <input type="hidden" value="1" name="quantity" />
          <button type="submit"  class="button button--tertiary">Add to Cart</button>
        </form>`;
          let showForm = hit.inventory_quantity > 0 && hit.inventory_available == true;
          return html`
              <img src="${algolia.helpers.sizedImage('medium', hit, false)}" loading="lazy" alt="${hit.title}" width="90" height="90" />
              <div class="product-replacement-parts__item-content">
                <h3>${hit.title}</h3>
              </div>
              <div class="product-replacement-parts__item-actions">
                ${showForm && form}
                <a href="${algolia.helpers.instantsearchLink(hit)}">View Details</a>
              </div>
            `;
        },
      },
    })
  ]);

  let formSubmit = () => {
    document.querySelectorAll('.product-replacement-parts__form').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(form);
        if (cart) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
              return;
            } else if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
            cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          });
      });
    })
  }

  function replacementPartsViewPartsBtn() {
    document.querySelectorAll('.product-replacement-parts__button--algolia').forEach(item => {
      item.addEventListener('click', ev => {
        ev.preventDefault();
        item.classList.toggle('hidden')
        item.parentNode.querySelector('.product-replacement-parts__grid').classList.toggle('active')
      });
    });
  }

  search.on('render', debounce((event) => {
    const hits = search.helper?.lastResults?.nbHits;
    if(hits && hits > 0) {
      container.style.display = "block";
      formSubmit();
      replacementPartsViewPartsBtn();
    }

  }, ON_CHANGE_DEBOUNCE_TIMER));

  search.start();

}

replacementPartsAlgolia (window.algoliaShopify);
// On variant change  
subscribe(PUB_SUB_EVENTS.variantChange, debounce((event) => {
  replacementPartsAlgolia (window.algoliaShopify);
}, ON_CHANGE_DEBOUNCE_TIMER));

